export enum LoginStatusResponse {
  SUCCESS = 0,
  TOKEN_EXPIRED = 58,
  REGISTRATION = 404,
  AGREEMENT = 403
}
